var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_1509_183965","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"25","key":0},React.createElement("rect",{"y":"0.5","width":"24","height":"24","fill":"black"})),React.createElement("g",{"mask":"url(#mask0_1509_183965)","key":1},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.0001 4.5L13.0001 19.5H11.0001L11.0001 4.5L13.0001 4.5Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.0001 21.9142L4.29297 14.2071L5.70718 12.7929L12.0001 19.0858L18.293 12.7929L19.7072 14.2071L12.0001 21.9142Z","fill":"white","key":1})])]);
}

ArrowDown.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
